import { LitElement } from 'lit';

/**
 *
 * - Opens native date picker on custom date icon click
 * - Opens native date picker on input focus
 */

export default class InputSelect extends LitElement {
  createRenderRoot() {
    return this;
  }

  /** @internal */
  get button() {
    return this.querySelector('button');
  }

  /** @internal */
  get label() {
    return this.querySelector('label');
  }

  /** @internal */
  get input() {
    return this.querySelector('select');
  }

  connectedCallback() {
    super.connectedCallback();

    this.button?.addEventListener('click', this);
    this.label?.addEventListener('click', this);
  }

  handleEvent(e) {
    e.type === 'click' && this.handleClick(e);
  }

  handleClick(e) {
    e.preventDefault();

    if (this.input.disabled) return;

    this.input.focus();

    /* showPicker method isn't available for iOS */
    if ('showPicker' in HTMLSelectElement.prototype) {
      this.input.showPicker();
    }
  }
}

customElements.get('bu-input-select') ||
  customElements.define('bu-input-select', InputSelect);
